export const formatedDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0'); // Ensure two digits for the day
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Ensure two digits for the month
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
};

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) {
      return 'Invalid date';
    }
    const day = String(date.getDate()).padStart(2, '0');
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return `${day} ${monthNames[monthIndex]} ${year}`;
  };
